module.exports = "<ubg-dashboard-stat [project]=\"project\" *ngIf=\"project !== null\"></ubg-dashboard-stat>"